/* ===== CLASSIC theme.js ===== */
(function(){
  function initHero(root){
    var track=root.querySelector('.slides');
    var dots=root.querySelector('.hero-dots');
    if(!track) return;
    var slides=track.children, n=slides.length, cur=0, timer;
    if(n<=1){ if(dots) dots.style.display='none';
      var ar=root.querySelectorAll('.hero-arrow'); ar.forEach(function(a){a.style.display='none';}); return; }
    function go(i){ cur=(i+n)%n; track.style.transform='translateX(-'+(cur*100)+'%)';
      if(dots){[].forEach.call(dots.children,function(d,k){d.classList.toggle('active',k===cur);});} }
    var next=root.querySelector('.hero-arrow.next'), prev=root.querySelector('.hero-arrow.prev');
    if(next) next.onclick=function(){go(cur+1);};
    if(prev) prev.onclick=function(){go(cur-1);};
    if(dots) dots.onclick=function(e){ if(e.target.dataset.i!=null) go(+e.target.dataset.i); };
    function play(){ timer=setInterval(function(){go(cur+1);},5000); }
    function stop(){ clearInterval(timer); }
    play();
    root.addEventListener('mouseenter',stop);
    root.addEventListener('mouseleave',play);
  }

  function initMenu(){
    var t=document.querySelector('.menu-toggle'), nav=document.querySelector('.nav');
    if(t&&nav) t.addEventListener('click',function(){nav.classList.toggle('open');});
  }

  function initGallery(){
    var main=document.querySelector('.pdp .gallery .main-img');
    var thumbs=document.querySelectorAll('.pdp .gallery .thumbs img');
    if(!main) return;
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ main.src=t.dataset.full||t.src; }); });
  }

  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('.hero').forEach(initHero);
    initMenu();
    initGallery();
  });
})();
